/*! ElitePelletsKopen - verplichte akkoord-vinkbox voor de checkout (v2: akkoord als cart-attribuut met tijdstip; v3: A/B-variant uit cookie epk_ab als attribuut Variant). Markup: snippets/epk-cart-terms.liquid */
(function(){
  "use strict";
  if(window.__epkTermsInit) return; window.__epkTermsInit=true;
  var KEY='epkTermsOk';
  function boxes(){ return [].slice.call(document.querySelectorAll('[data-epk-terms]')); }
  function ok(){ try{ return sessionStorage.getItem(KEY)==='1'; }catch(e){ return !!window.__epkTermsOk; } }
  function setOk(v){ window.__epkTermsOk=!!v; try{ if(v) sessionStorage.setItem(KEY,'1'); else sessionStorage.removeItem(KEY); }catch(e){} }
  function stamp(){ var d=new Date(), p=function(n){return (n<10?'0':'')+n;}; return p(d.getDate())+'-'+p(d.getMonth()+1)+'-'+d.getFullYear()+' '+p(d.getHours())+':'+p(d.getMinutes()); }
  function saveAttr(v){
    var attrs=v?{'Akkoord algemene voorwaarden':'Ja','Akkoord voorwaarden op':stamp()}:{'Akkoord algemene voorwaarden':'','Akkoord voorwaarden op':''};
    try{ var ab=document.cookie.match(/(?:^|; )epk_ab=([AB])/); if(ab) attrs['Variant']=ab[1]; }catch(e){} /* v3: A/B-variant op de bestelling */
    try{ fetch((window.routes&&window.routes.cart_update_url)||'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:attrs})}).catch(function(){}); }catch(e){}
  }
  function sync(){
    var v=ok();
    boxes().forEach(function(b){
      var cb=b.querySelector('input.epk-terms__cb'); if(cb&&cb.checked!==v) cb.checked=v;
      if(v&&b.classList.contains('epk-terms--error')){ b.classList.remove('epk-terms--error'); var e=b.querySelector('.epk-terms__err'); if(e) e.hidden=true; }
    });
    var want=v?'':'none';
    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function(d){ if(d.style.display!==want) d.style.display=want; });
  }
  function visibleBox(){ var bs=boxes(); for(var i=0;i<bs.length;i++){ var cs=getComputedStyle(bs[i]); if(cs.visibility!=='hidden'&&cs.display!=='none'&&bs[i].offsetParent!==null) return bs[i]; } return bs[0]||null; }
  function block(e){
    var box=visibleBox(); if(!box) return;
    e.preventDefault(); e.stopPropagation();
    box.classList.add('epk-terms--error'); var err=box.querySelector('.epk-terms__err'); if(err) err.hidden=false;
    try{ box.scrollIntoView({block:'center'}); }catch(x){}
    var cb=box.querySelector('input.epk-terms__cb'); if(cb){ try{ cb.focus({preventScroll:true}); }catch(x){} }
  }
  document.addEventListener('change',function(e){ var t=e.target; if(t&&t.classList&&t.classList.contains('epk-terms__cb')){ setOk(t.checked); saveAttr(t.checked); sync(); } },true);
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var btn=t.closest('button[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]');
    if(!btn||ok()) return;
    block(e);
  },true);
  document.addEventListener('submit',function(e){ var s=e.submitter; if(s&&s.name==='checkout'&&!ok()) block(e); },true);
  new MutationObserver(function(){ sync(); }).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sync); else sync();
})();
